export default "__VITE_ASSET__D1Ymxw$___"